import { paramCase } from '@client/common/utils/string/string';
import { v4 as generateUuid } from 'uuid';

export const createKey = (...params: Array<string | number>): string => ['x', ...params].map((param) => paramCase(`${param}`)).join('-');

export const generateUnique = (): string => `x${generateUuid().replace(/[^\d\w]/gm, '')}`;

